<template>
  <div id="profit-items">
    <div>
      <div class="h2" style="text-align: center">
        {{ $t('profitableKitTitle') }}
      </div>
    </div>
    <ul class="products columns-6 seasidetms_products col-md-12">
      <li
        v-for="(item, i) in profitItems"
        :key="`pi${i}`"
        class="product"
        :class="
          item._id.match(/eq|plus/)
            ? `item-${item._id} item-${i}`
            : `normal-${i}`
        "
      >
        <div v-if="item._id === 'plus'" style="text-align: center">
          <span class="profit-items-symbol">+</span>
        </div>
        <div v-else-if="item._id === 'eq'" style="text-align: center">
          <span class="profit-items-symbol">=</span>
          <div style="text-align: center">
            <div class="h5 price-uc">
              <span v-html="$h.formatPrice(totalPriceUnchain)"></span>грн
            </div>
          </div>
          <div>
            <div
              class="h3"
              style="text-align: center; color: rgba(255, 67, 0, 0.9)"
            >
              <span v-html="$h.formatPrice(totalPrice)"></span>грн
            </div>
          </div>
          <!-- <div style="text-align:center">
            <h6 class="price-uc">
              ₴<span
                v-html="$h.formatPrice(totalPriceUnchain - totalPrice)"
              ></span>
            </h6>
          </div> -->
          <div class="profit-buy">
            <button
              type="button"
              name="add-to-cart"
              class="single_add_to_cart_button button alt buy-profitable-kit"
              @click.stop.prevent="onOrder(i)"
              v-if="!alreadyInCart"
            >
              {{ $t('buyProfitableKit') }}
            </button>
            <router-link
              :to="lang ? '/' + lang + '/cart' : '/cart'"
              class="single_add_to_cart_button button alt"
              v-else
            >
              {{ $t('showCart') }}
            </router-link>
          </div>
        </div>
        <div v-else class="seasidetms_product_wrapper_border">
          <span class="kitDisc" v-if="(i == 2 || i == 4) && product.kitDisc">
            -{{ product.kitDisc }}%
          </span>
          <span class="kitDisc" v-else-if="i == 2 || i == 4"> -20% </span>
          <div class="product-image-wrapper" style="text-align: center">
            <router-link
              :to="
                lang
                  ? '/' + lang + '/product/' + item.id
                  : '/product/' + item.id
              "
              @click.native="onClickProdcut(item, i)"
            >
              <img
                :width="210"
                :height="210"
                :src="'https://apptown.com.ua' + productImgSrc(item)"
                :alt="productName(item)"
                class="product-image attachment-woocommerce_thumbnail size-woocommerce_thumbnail lazyloaded"
              />
              <!--              :sizes="productImgSizes(item)"-->
              <!--              :srcset="productImgSrcSet(item)"-->
            </router-link>
          </div>
          <div style="text-align: center">
            <b>{{ productName(item) }}</b>
          </div>
          <div style="text-align: center" v-if="item.price || item.newPrice">
            <s>
              <span
                v-html="$h.formatPrice(i === 0 ? item.price : getPrice(item))"
              ></span
              >грн
            </s>
          </div>
          <div style="text-align: center; color: rgba(255, 67, 0, 0.9)">
            <span v-html="$h.formatPrice(getSalePrice(item, i))"></span>грн
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'ProfitableProducts',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    warranties: {
      type: Array,
    },
  },
  data() {
    return {
      isInCart: false,
      lang: '',
    }
  },
  computed: {
    products() {
      let a = []
      if (
        Array.isArray(this.product.profitableKit) &&
        this.product.profitableKit.length
      ) {
        a.push(this.product)
        a = a.concat(this.product.profitableKit)
      }
      return a
    },
    profitItems() {
      let a = []
      this.products.forEach((p, i, arr) => {
        if (i > 0) {
          a.push({ _id: 'plus' })
        }
        a.push(p)
        if (i === arr.length - 1 && arr.length !== 1) {
          a.push({ _id: 'eq' })
        }
      })

      return a
    },
    totalPriceUnchain() {
      return this.products.reduce((acc, cur) => {
        const price = cur.price
        return acc + price
      }, 0)
    },
    totalPrice() {
      return this.products.reduce((acc, item, i) => {
        const price = this.getSalePrice(item, i)
        return acc + price
      }, 0)
    },
    alreadyInCart() {
      const inCart = !!this.$store.state.cart.items.find(
        (item) => item.id === this.product._id
      )
      return inCart
    },
  },
  methods: {
    getSalePrice(p, i) {
      const innerPrice = this.getPrice(p)

      if (i === 0) {
        return innerPrice
      }

      if (this.product.kitDisc) {
        return Math.ceil(innerPrice - innerPrice * (this.product.kitDisc / 100))
      } else {
        return Math.ceil(innerPrice * 0.8)
      }
    },
    getPrice(p) {
      return p.newPrice ? p.newPrice : p.price
    },
    productImgSrc(product) {
      return Array.isArray(product.img) && product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    productImgSrcSet(product) {
      // extract missing w from filenames
      return product.srcset
        ? product.srcset
            .map((v) => {
              let m = v.match(/(\d+)x\d+\.(png|jpg|jpeg|gif)$/i)
              if (m && m.length > 1) {
                return `https://apptown.com.ua/img${v} ${m[1]}w`
              } else {
                return `https://apptown.com.ua/img${v} 75w`
              }
            })
            .join(',')
        : ''
    },
    productImgSizes(product) {
      return this.productImgSrcSet(product)
        ? '(max-width: 540px) 100vw, 540px'
        : ''
    },
    productImgWidth(product) {
      if (product.srcset && product.srcset.find((v) => v.match('540x540'))) {
        return 540
      }
      return 410
    },
    productImgHeight(product) {
      if (product.srcset && product.srcset.find((v) => v.match('580x410'))) {
        return 410
      }
      return 415
    },
    productName(product) {
      return product[`name_${this.$i18n.locale}`]
        ? product[`name_${this.$i18n.locale}`]
        : product.name
        ? product.name
        : ''
    },
    itemClass(item) {
      if (item._id === 'plus') {
        return 'op'
      } else {
        return 'product'
      }
    },
    onOrder(i) {
      const inCart = !!this.$store.state.cart.items.find(
        (item) => item.id === this.product._id
      )
      if (!inCart) {
        let item = {}
        Object.assign(
          item,
          this.product,
          { warranty: this.warranties },
          { single: false }
        )
        let variant = ''
        let p = this.product
        if (p['filters']) {
          if (p['filters'][0]['color']) {
            variant = p['filters'][0]['color']
          }
          if (variant && p['filters'][0]['memory']) {
            variant = variant + ' ' + p['filters'][0]['memory']
          }
        }
        let listcat_full = this.categoryName(p)

        this.$h.gtmDataLayerPush({
          ecomm_pagetype: 'cart',
          ecomm_prodid: p['id'],
          ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
        })
        const item_list_id = uuidv4()
        this.$gtag.event('add_to_cart', {
          items: [
            {
              item_name: p[`name_${this.$i18n.locale}`],
              item_id: p['id'],
              price: p['newPrice'] ? p['newPrice'] : p['price'],
              currency: 'UAH',
              item_brand: 'Apple',
              item_category: listcat_full,
              item_list_name: 'Product page set',
              item_list_id,
              index: i || 0,
              quantity: 1,
            },
          ],
        })
        this.$store
          .dispatch('addToCart', item)
          .then(() => {
            console.log('*ADDED')
            // this.$h.id('profit-items').style.display = 'none'
            this.isInCart = true
          })
          .catch(() => {
            console.log('*ERROR')
          })
      }
    },
    categoryName(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach((p) => {
        if (!_c) return
        let c = _c.find((c) => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c[`name_${this.$i18n.locale}`]
        }
      })
      return path
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
#profit-items {
  display: block;
  height: 300px;
  text-align: center;
  width: 80%;
  margin: 0 auto;
}
.item-plus {
  width: 6% !important;
  padding-top: 50px !important;
}
.item-eq {
  width: 30% !important;
}
.price-uc {
  display: inline;
  text-decoration: line-through;
  color: #818181;
}
.profit-buy {
  text-align: center;
  margin: 0 15px;
  margin-top: 20px;
  min-width: 200px;
}
/*.normal-2::after,*/
/*.normal-4::after {*/
/*  content: '-20%';*/
/*  position: absolute;*/
/*  top: 10px;*/
/*  right: -10px;*/
/*  background: rgba(255, 67, 0, 0.9);*/
/*  border-radius: 10px;*/
/*  color: #fff;*/
/*  padding: 0 5px;*/
/*  font-size: 12px;*/
/*}*/

.kitDisc {
  position: absolute;
  top: 10px;
  right: -10px;
  background: rgba(255, 67, 0, 0.9);
  border-radius: 10px;
  color: #fff;
  padding: 0 5px;
  font-size: 12px;
}
.product-image {
  max-height: 104px;
  object-fit: cover;
}
.product-image-wrapper {
  height: 105px;
}

@media only screen and (max-width: 992px) {
  #profit-items {
    height: auto;
  }
}
@media only screen and (max-width: 768px) {
  #profit-items {
    height: auto;
  }
  .item-plus,
  .item-eq {
    width: 100% !important;
  }
  .item-eq {
    margin-bottom: 40px;
  }
  .product-image {
    max-height: unset;
    object-fit: unset;
  }
  .product-image-wrapper {
    height: unset;
  }
  .kitDisc {
    top: -10px;
    right: 50px;
    font-size: 12px;
  }
}
@media (max-width: 670px) {
  .kitDisc {
    right: 30px;
  }
}
@media (max-width: 670px) {
  .kitDisc {
    right: 10px;
  }
}
@media (max-width: 500px) {
  .kitDisc {
    right: 0px;
  }
}
@media only screen and (max-width: 450px) {
  /*.normal-2::after, .normal-4::after {*/
  /*  content: '-20%';*/
  /*  position: absolute;*/
  /*  top: 4px;*/
  /*  right: 4px;*/
  /*  background: rgba(255, 67, 0, 0.9);*/
  /*  border-radius: 10px;*/
  /*  color: #fff;*/
  /*  padding: 0 5px;*/
  /*  font-size: 12px;*/
  /*}*/
}
.profit-items-symbol {
  font-family: 'Nunito', sans-serif;
  font-size: 38px;
  line-height: 46px;
  font-weight: 400;
  font-style: normal;
  text-transform: none;
  text-decoration: none;
  margin: 0 0 20px;
  color: #444444;
  display: block;
}
</style>
